import React, { useCallback, useState } from "react";
import {
  View,
  Text,
  Dimensions,
  TextInput,
  Image,
  TouchableOpacity,
  StyleSheet,
  ActivityIndicator,
} from "react-native";
import { MascotBlack } from "../common/icons/mascot_black";
import { api } from "../api/api";
import { colors } from "../common/styles/colors";
import { fonts } from "../common/styles/fonts";
import { GadderLogoBlack } from "../common/icons/GadderLogoBlack";

export const CheckCodePage = () => {
  const [code, setCode] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [requestState, setRequestState] = useState<"success" | "error" | null>(
    null
  );

  const checkHandler = useCallback(() => {
    setIsLoading(true);

    api.rewards
      .postCheckCodeReward({ code })
      .then((response) => {
        setRequestState(response.data.code === code ? "success" : "error");

        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response.status === 400) {
          setRequestState("error");
        }
        setIsLoading(false);
      });
  }, [code]);

  return (
    <View
      style={{
        height: Dimensions.get("window").height,
        justifyContent: "center",
        flexDirection: "row",
        backgroundColor: colors.white,
      }}
    >
      <View
        style={[
          { justifyContent: isLoading ? "flex-start" : "space-between" },
          styles.container,
        ]}
      >
        <View style={{ alignItems: "center" }}>
          <MascotBlack style={{ marginBottom: 24 }} />
          <GadderLogoBlack style={{ marginBottom: 24 }} />
          <Text style={[styles.title, fonts.title]}>
            {!requestState
              ? "Enter client code"
              : requestState === "success"
              ? "You are good to go."
              : "This code did not work. \n" + "please try again "}
          </Text>
        </View>
        {isLoading ? (
          <ActivityIndicator
            style={{ paddingTop: 140 }}
            color={colors.LightGrayishYellow}
          />
        ) : (
          <>
            <View style={{ alignSelf: "stretch" }}>
              {!requestState ? (
                <TextInput
                  value={code}
                  placeholderTextColor={colors.black}
                  placeholder={"enter code here"}
                  textAlign={"center"}
                  onChangeText={(text) => setCode(text)}
                  style={[fonts.input, styles.input]}
                />
              ) : requestState === "success" ? (
                <Image
                  source={require("../common/images/checkGreen.png")}
                  style={styles.image}
                />
              ) : (
                <Image
                  source={require("../common/images/crossRed.png")}
                  style={styles.image}
                />
              )}
            </View>

            <TouchableOpacity
              disabled={!requestState && code === ""}
              onPress={
                !requestState ? checkHandler : () => setRequestState(null)
              }
            >
              <View style={styles.button}>
                <Text
                  numberOfLines={1}
                  style={[
                    { color: colors.black, fontSize: 18, lineHeight: 18 },
                    fonts.mediumText_bold,
                  ]}
                >
                  {!requestState
                    ? "Check"
                    : requestState === "success"
                    ? "Confirm"
                    : "Try again"}
                </Text>
              </View>
            </TouchableOpacity>
            <View style={styles.instructionsContainer}>
              <Text style={[fonts.mediumText_bold, { marginBottom: 10 }]}>
                Instructions:
              </Text>
              <ol type="1" style={styles.list}>
                <li>
                  Please ask the customer to provide you with a 6 digit code (to
                  reveal the code the customer must tap on their completed
                  reward )
                </li>
                <li>
                  Please enter the code in the field above and press check
                </li>
                <li>If you see a green tick that mean the code is valid</li>
                <li>
                  If there is a red cross that means the code provided is not
                  valid. (please ask customer to repeat, if problem occurs the
                  code is not valid and this user is not yet eligible for the
                  reward)
                </li>
              </ol>
              <Text style={fonts.smallText_bold}>
                For any support or any questions please email:
                hello@gadderapp.com
              </Text>
            </View>
          </>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    maxWidth: 650,
    paddingTop: 54,
    paddingBottom: 35,
    height: Dimensions.get("window").height,
  },
  title: {
    textAlign: "center",
    color: colors.black,
    alignSelf: "center",
    marginBottom: 24,
  },
  input: {
    backgroundColor: colors.LightGrayishYellow,
    marginHorizontal: 32,
    borderRadius: 30,
    paddingVertical: 16,
    paddingHorizontal: 16,
    color: colors.black,
    textAlign: "center",
    borderWidth: 1,
    borderColor: colors.black,
  },
  image: { width: 116, height: 116, alignSelf: "center" },
  button: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    borderRadius: 28,
    paddingVertical: 12,
    paddingHorizontal: 24,
    backgroundColor: "transparent",
    borderColor: colors.black,
    borderWidth: 1,
  },
  instructionsContainer: {
    marginHorizontal: 20,
    alignItems: "flex-start",
  },
  list: {
    ...fonts.smallText_regular,
    lineHeight: "normal",
    paddingLeft: "10px",
  },
});
